import { memo } from 'react';

import { useTranslation } from '@wearehelpful/ui-localization';
import { Form, useFormControl } from '@wearehelpful/ui-kit';
import { useBootstrapData } from '@bootstrap/hooks';
import { BDTO, ContentfulDocument } from '@helpful/network';

export const PatientForm = memo(() => {
  const { t } = useTranslation();

  const { hints } = useBootstrapData();

  const hint = hints.find(
    ({ type }) =>
      type === BDTO.HintItemType['why-do-we-need-this-info-sign-up-details']
  );

  const [caregiverFirstName] = useFormControl({
    name: 'caregiver.firstName',
    watch: true,
  });

  const [caregiverLastName] = useFormControl({
    name: 'caregiver.lastName',
    watch: true,
  });

  const [, { setValue: setPatientFirstName }] = useFormControl({
    name: 'patient.firstName',
    watch: true,
  });

  const [, { setValue: setPatientLastName }] = useFormControl({
    name: 'patient.lastName',
    watch: true,
  });

  const handleOnCaringForMyselfChange = (value: boolean) => {
    if (value) {
      setPatientFirstName(caregiverFirstName);
      setPatientLastName(caregiverLastName);
    }
  };

  return (
    <Form.Section>
      <Form.Checkbox
        name="caringForMyself"
        label={t('forms.caringForMyself')}
        onChange={handleOnCaringForMyselfChange}
      />
      <Form.Text
        tabIndex={3}
        autocapitalize="on"
        name="patient.firstName"
        validation={{ required: true }}
        label={t('forms.lovedOnesFirstName')}
        help={t('hints.lovedOnesFirstNameAsInInsurance')}
      />
      <Form.Text
        tabIndex={4}
        autocapitalize="on"
        name="patient.lastName"
        validation={{ required: true }}
        label={t('forms.lovedOnesLastName')}
        help={t('hints.lovedOnesLastNameAsInInsurance')}
      />
      {!!hint && (
        <Form.Hint
          title={hint.title}
          message={
            <ContentfulDocument>
              {hint.longDescription as any}
            </ContentfulDocument>
          }
        >
          {hint.shortDescription}
        </Form.Hint>
      )}
    </Form.Section>
  );
});
